// extracted by mini-css-extract-plugin
export default {"center":"projects_center__H-KZT"};